import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { WelletContext } from '../../../context/WelletContext';
import { useTranslation } from 'react-i18next';
import Header from '../../../components/Common/Header/Header';
import SuccessScreen from '../../Common/SuccessScreen';
import Button from '../../../components/Common/Button/Button';
import { getPaymentMethod } from '../../../actions/associatesActions';
import StripeIcon from '../../../components/icons/stripe';
import styles from './stripe.module.css';
import SuccessCheck from '../../../components/icons/SuccessCheck';

const LinkStripeConnect = ({ history }) => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const dispatch = useDispatch();
  const [withdrawalMethod, setWithdrawalMethod] = useState(null);
  const [accountNumber, setAccountNumber] = useState('0110000600000000000000');
  const [country, setCountry] = useState('AR');
  const [currency, setCurrency] = useState('ARS');
  const [isSubmitting, setIsSubmitting] = useState(false);


  const createBankAccount = async () => {
    try {
      setIsSubmitting(true);
      const response = await welletContext.apis.tickets.post('/withdrawal/accounts', {
        bankAccount: {
          accountNumber,
          country,
          currency,
        }
      });

      if(response.data.isComplete) {
        refreshWithdrawalMethod();
      }
      setIsSubmitting(false);

      return response.data;
    } catch (error) {
      setIsSubmitting(false);
      console.error(error);
    }
  };

  const refreshWithdrawalMethod = async () => {
    try {
      const withdrawalMethodResult = await getPaymentMethod(welletContext);
      dispatch({
        type: 'USER_WITHDRAWAL',
        payload: withdrawalMethodResult.data,
      });
      setWithdrawalMethod(withdrawalMethodResult.data);
    } catch (error) {
      setWithdrawalMethod('none');
    }
  };

  useEffect(() => {
    refreshWithdrawalMethod();
  }, []);

  const isSubmitEnabled = () => {
    
    
    if(isSubmitting) {
      return false;
    }


    return accountNumber !== '' && country !== '' && currency !== '';
  }
  
  const renderBody = () => {
    if (withdrawalMethod === null) {
      return null;
    }

    return (
      <div className={styles.container}>
        <Header title={t('stripe.receivePayments')} />
        <div className={styles.logo}>
          <StripeIcon size='102px' />
        </div>
        <div className={styles.instructionsTitle}>
          {t('stripe.ReceivePaymentsIntoYourBankAccount')}
        </div>
        <div className={styles.instructionsSubTitle}>{t('stripe.startReceivingPayments')}</div>
        <form>
          <div className="row">
            <label htmlFor="accountNumber">CBU</label>
            <input type="text" id="accountNumber" value={accountNumber} onChange={setAccountNumber} />
          </div>
          <div className="row">
            <label htmlFor="country">Pais</label>
            <input type="text" id="country" value={country} onChange={e => setCountry(e.value)} />
          </div>
          <div className="row">
            <label htmlFor="currency">Moneda</label>
            <input type="text" id="currency" value={currency} onChange={setCurrency} />
          </div>
        </form>
        <div className={styles.button}>
          <Button
            text={t('stripe.linkAccount')}
            size='large'
            icon
            typeIcon='arrow'
            color='#000'
            className='btn-primary'
            iconColor='#000'
            onClick={() => createBankAccount()}
            disabled={!isSubmitEnabled()}
          />
        </div>
      </div>
    );
  };

  if (withdrawalMethod !== null && withdrawalMethod !== 'none') {
    return (
      <SuccessScreen
        title='Se ha vinculado tu cuenta bancaria exitosamente'
        subtitle={`Hemos vinculado tu cuenta bancaria exitosamente.`}
        path='/'
      />
    );
  }

  return <>{renderBody()}</>;
};

export default LinkStripeConnect;
